<template>
    <transition :name="'fade'" mode="out-in">
        <div id="spot_modal_modal" v-if="spotData.visible">
            <CustomReveal class="event-modal"
                revealId="event-profile-card"
                v-if="spotData.mode !== 'create'"
                :isVisible="spotData.visible"
                v-on:close-reveal-event-profile-card="closeEvent">
                <div id="event-profile-card" class="event-card"
                    data-reveal2>
                    <ViewSpot v-if="spotData.mode === 'view'"/>
                    <EditSpot v-if="spotData.mode === 'edit'"/>
                </div>

                <UserPhotosReveals v-if="spot" :photos="spot.photos"></UserPhotosReveals>
                <UserVideosReveals v-if="spot" :videos="spot.videos"></UserVideosReveals>
            </CustomReveal>

            <CreateEvent v-if="spotData.mode === 'create'"/>

        </div>
    </transition>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
    import UserPhotosReveals from '@buddy/views/widgets/UserPhotosReveals.vue';
    import UserVideosReveals from '@buddy/views/widgets/UserVideosReveals.vue';

    import ViewSpot from '@events/views/desktop/spot/Item.vue';
    import EditSpot from '@events/views/desktop/spot/Edit.vue';
    import EditEvent from '@events/views/desktop/event/Edit.vue';
    import CreateEvent from '@events/views/desktop/event/Create.vue';

    import eventsModule from '@events/module/store/type'

    export default {
        mixins: [
            require('@general/lib/mixin-events').default,
        ],
        components: {
            CustomReveal,
            UserPhotosReveals,
            UserVideosReveals,
            EditEvent,
            ViewSpot,
            EditSpot,
            CreateEvent
        },
        computed: {
            ...mapGetters({
                spotData: eventsModule.getters.spot
            }),
            spot(){
                return this.$store.getters.getSpot(this.spotData.id)
            },
        },
        methods: {
            ...mapActions({
                setEvent: eventsModule.actions.setEvent
            })
        },
        watch:{
          'spotData': function (loading){
            console.log('CHANGE SPOT DATA',loading)
          }
        }
    }
</script>
